module.exports = __webpack_public_path__ + "img/左2logo.42ad8271.png";